const coupons = [
	{
		path: '/deals/coupons',
		name: 'shop-coupons-list',
		component: () => import('@/views/shop/coupons/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,product-suppliers',
		},
	},
]

export default coupons
